export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-152x152-c02efbc8b3c39dfe9a05fae0790e6ed4.png";